import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalBootstrap from "components/bootstrap/ModalBootstrap";
import SubTitle from "components/SubTitle";
import { useGetReversedDecisionsQuery } from "features/api/reports/reportsSlice";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import ReversedDecisionModalBody from "./reversedDecisionModalBody";

type ReversingDecisionsProps = {
  selectedDatePeriod;
  startDateString;
  endDateString;
};
const ReversingDecisions = ({
  selectedDatePeriod,
  startDateString,
  endDateString,
}: ReversingDecisionsProps) => {
  const { t } = useTranslation();
  const [modalShow, setModalShow] = useState(false);

  const userId = useGetUserData(LocalStorageKey.UserId);

  const { data: reversedDecisions, isLoading } = useGetReversedDecisionsQuery({
    start: startDateString ?? startDateString,
    end: endDateString ?? endDateString,
    userId,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (reversedDecisions) {
    return (
      <>
        <button type="button" onClick={() => setModalShow(true)}>
          <SubTitle
            fontSize="1.8rem"
            fontWeight="bold"
            className="angel-left"
            style={{ textDecoration: "underLine", textUnderlineOffset: "5px" }}
          >
            {`${t("reverseAnnouncment")} ${reversedDecisions.length} ${t(
              "reports"
            )}`}
          </SubTitle>
        </button>
        <ModalBootstrap onHide={() => setModalShow(false)} show={modalShow}>
          <ReversedDecisionModalBody
            selectedDatePeriod={selectedDatePeriod}
            startDateString={startDateString}
            userId={userId}
          />
        </ModalBootstrap>
      </>
    );
  }
  return null;
};

export default ReversingDecisions;
